import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ResultsData } from "../../state/BookingCreateManager/ResultsData";

const updateResultsData: Reducer<ResultsData> = (state: ResultsData = new ResultsData(), action: Action<ActionType, ResultsData>) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_DATA_FETCHED:
      return { ...state, ruleList: action.data};
    case ActionType.BOOKING_CREATE_MANAGER_DATA_LIST_ROW_DELETED:
      let newRuleList = state.ruleList.filter(item => item.id !== action.data.id);
      return { ...state, ruleList: newRuleList };
    default:
      return state;
  }
};

export default updateResultsData;
